import React from "react";

const EduAndExp = () =>
{
    return (
      <>
        <div className="salv-about-edu-expr">
          <div className="row sal-about-eduction-row">
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 salv-eduction-col">
              <h6 className="salv-about-personla-title mb-0 b-text sm-md-font inter-font-700 mb-0">
                eduction
              </h6>
              <div className="about-educ-card-wrap">
                <div className="eduction-card edu-card-one">
                  <div className="year-edu-className">
                    <div className="educ-year">2018 - 2020</div>
                    <p className="about-edu-title sm-md-font b-text inter-font-500 mb-0">
                      Master in Developing
                    </p>
                  </div>
                  <div className="about-desc sm-font-two inter-font-400 second-color">
                    Morbi nullam sit dolor diam aenean gravida. Eget commodo
                    blandit volutpat quis tristique risus, sed. Sed et.
                  </div>
                </div>
                <div className="eduction-card edu-card-two">
                  <div className="year-edu-className">
                    <div className="educ-year">2016 - 2018</div>
                    <p className="about-edu-title sm-md-font b-text inter-font-500 mb-0">
                      Master in Designing
                    </p>
                  </div>
                  <div className="about-desc sm-font-two inter-font-400 second-color">
                    Morbi nullam sit dolor diam aenean gravida. Eget commodo
                    blandit volutpat quis tristique risus, sed. Sed et.
                  </div>
                </div>
                <div className="eduction-card edu-card-three">
                  <div className="year-edu-className">
                    <div className="educ-year">2016 - 2014</div>
                    <p className="about-edu-title sm-md-font b-text inter-font-500 mb-0">
                      Univercity of Art
                    </p>
                  </div>
                  <div className="about-desc sm-font-two inter-font-400 second-color">
                    Morbi nullam sit dolor diam aenean gravida. Eget commodo
                    blandit volutpat quis tristique risus, sed. Sed et.
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 salv-experience-col">
              <h6 className="salv-about-personla-title mb-0 b-text sm-md-font inter-font-700 mb-0">
                experience
              </h6>
              <div className="about-educ-card-wrap">
                <div className="eduction-card edu-card-one">
                  <div className="year-edu-className">
                    <div className="educ-year">2022 - Running</div>
                    <p className="about-edu-title sm-md-font b-text inter-font-500 mb-0">
                      Envato Elements
                    </p>
                  </div>
                  <div className="about-desc sm-font-two inter-font-400 second-color">
                    Morbi nullam sit dolor diam aenean gravida. Eget commodo
                    blandit volutpat quis tristique risus, sed. Sed et.
                  </div>
                </div>
                <div className="eduction-card edu-card-two">
                  <div className="year-edu-className">
                    <div className="educ-year">2021 - 2022</div>
                    <p className="about-edu-title sm-md-font b-text inter-font-500 mb-0">
                      ThemeForest
                    </p>
                  </div>
                  <div className="about-desc sm-font-two inter-font-400 second-color">
                    Morbi nullam sit dolor diam aenean gravida. Eget commodo
                    blandit volutpat quis tristique risus, sed. Sed et.
                  </div>
                </div>
                <div className="eduction-card edu-card-three">
                  <div className="year-edu-className">
                    <div className="educ-year">2020 - 2021</div>
                    <p className="about-edu-title sm-md-font b-text inter-font-500 mb-0">
                      Graphicriver
                    </p>
                  </div>
                  <div className="about-desc sm-font-two inter-font-400 second-color">
                    Morbi nullam sit dolor diam aenean gravida. Eget commodo
                    blandit volutpat quis tristique risus, sed. Sed et.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
};
export default EduAndExp;